import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as reportAction from './../../../../../../actions/reportAction';
import * as orderAction from './../../../../../../actions/orderAction';
import SaleReportsBySKU from './SaleReportsBySKU';

const mapStateToProps = state => {
    return {
        reportState: state.reportReducer,
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSaleReportBySKU: (filters) => dispatch(reportAction.getSaleReportBySKU(filters)),
        exportSkuExcel: filters => dispatch(orderAction.exportSkuExcel(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SaleReportsBySKU));
